import { Box } from "@mui/material";
import * as React from "react";

interface Props {
    label: string;
    value: number;
}

export const StatisticBadgeNew = (props: Props) => (
    <Box>
        <Box
            sx={{
                backgroundColor: "secondary.main",
                color: "secondary.contrastText",
                borderRadius: 1,
                padding: "0 10px",
                fontWeight: "bold",
                fontSize: { xs: "0.7rem", sm: "0.9rem", md: "1rem" },
                height: "4.2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
            }}
        >
            {props.label}
        </Box>
        <Box sx={{ fontSize: "4rem" }}>{props.value}</Box>
    </Box>
);
